import { Facebook, LinkedIn, MailOutline, Twitter } from "@mui/icons-material";
import { Link, withPrefix } from "gatsby";
import React, { FunctionComponent, useContext, useState } from "react";
import { LoginButton } from "../components/buttons";
import { AuthLink, GatedLink } from "../components/links";
import { StyledNavbar } from "../components/styled";
import { EventAwareText as EAText } from "../components/text";
import Context from "../context/Context";
import useEventDetails from "../hooks/useEventDetails";

const Navbar: FunctionComponent = (props: any, { onToggle }) => {
  const { virtual, eventEndTime } = useEventDetails();
  const [state, setState] = useState(false);
  const data = useContext(Context);
  const { navPagesDefault, navPagesSingle, socialShare, activeLink } = data;
  const navData = virtual ? navPagesSingle : navPagesDefault;
  const showHide = () => {
    onToggle && onToggle(!state);
    setState(!state);
  };

  const closeModal = () => {
    setState(false);
  };

  const closeMenu = () => {
    setState(false);
  };

  const actLink = activeLink;

  return (
    <StyledNavbar>
      <div className="toggleContainer">
        <div className="branding">
          <Link to={"/"}>
            <img
              src={withPrefix("/images/FedTalks_Nav.svg")}
              alt="FEDTALKS"
              className="logo"
            />
          </Link>
        </div>
        <div className="togBtn">
          <a
            onClick={showHide}
            className={`navTogglebtnOpen ${state ? "open" : "close"}`}
          >
            <img
              src={withPrefix(`/images/closeX.png`)}
              alt="close"
              width="16px"
              style={{ marginTop: "10px" }}
            />
          </a>
          <a
            onClick={showHide}
            className={`navTogglebtnClose ${state ? "close" : "open"}`}
          >
            <img
              src={withPrefix(`/images/menuToggle.png`)}
              alt="menu"
              width="20px"
            />
          </a>
        </div>
      </div>
      <div className={`pages ${state ? "open" : "close"}`}>
        {true &&
          navData
            .map((page, index: number) => {
              const showLink =
                page.showAfterEvent === undefined ||
                page.showAfterEvent === null ||
                (page.showAfterEvent && eventEndTime < Date.now()) ||
                (!page.showAfterEvent && eventEndTime > Date.now());

              if (!showLink) {
                return null;
              }
              const activeClass = activeLink === page.name ? "active-link" : "";
              if (page.path === "/live") {
                page.name = (
                  <EAText
                    key={index}
                    text={{
                      after: "On Demand",
                      default: "On Demand",
                    }}
                  ></EAText>
                );
              }
              if (page.disabled) {
                return (
                  <GatedLink
                    key={index}
                    to={page.path}
                    className={`page ${activeClass}`}
                    target={page.target}
                    onClick={closeModal}
                  >
                    {page.name}
                  </GatedLink>
                );
              } else if (page.auth) {
                return (
                  <AuthLink
                    key={index}
                    to={page.path}
                    className={`page ${activeClass}`}
                    target={page.target}
                  >
                    {page.name}
                  </AuthLink>
                );
              } else if (
                page.path &&
                page.path.startsWith(("mailto", "mailto"))
              ) {
                return (
                  <a
                    key={index}
                    href={page.path}
                    target={page.target}
                    className={`page ${activeClass}`}
                  >
                    {page.name}
                  </a>
                );
              } else {
                let path =
                  page.path && page.path.startsWith(("https", "https"))
                    ? page.path
                    : withPrefix(page.path);
                return (
                  <a
                    key={index}
                    href={path}
                    target={page.target}
                    className={`page ${activeClass}`}
                    onClick={closeMenu}
                  >
                    {page.name}
                  </a>
                );
              }
            })
            .filter(Boolean)}
        <LoginButton className="page login" closeMenu={closeMenu} />
        <div className="social-nav-container">
          {socialShare.map((social, index: number) => {
            const IconRender = () => {
              switch (social.alt) {
                case "facebook":
                  return <Facebook color="red" />;
                case "twitter":
                  return <Twitter />;
                case "linkedin":
                  return <LinkedIn />;
                case "email":
                  return <MailOutline />;
                default:
                  return null;
              }
            };
            return (
              <a
                key={index}
                className="social-icon"
                href={social.path}
                target={"_blank"}
              >
                {IconRender()}
              </a>
            );
          })}
        </div>
      </div>
    </StyledNavbar>
  );
};

export default Navbar;
